/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
// @flow
import React from 'react';

import styles from './styles.module.scss';
import { sortCards } from '../../../utils/game/sortRandomCards';
import PlayingCard from 'components/PlayingCard';
import FreeModal from 'components/FreeModal/FreeModal';

type MistakeItemProps = {
  answer: string[],
  bb: string,
  combo: string,
  ev_c: number,
  ev_f: number,
  ev_r: number,
  stake: string,
  ts: string,
  weight_c: number,
  weight_f: number,
  weight_r: number,
  isEasyRFI: boolean,
  easyFold: boolean,
  seeRange: () => void,
  itemData: any,
  isPlo5: boolean,
  isFreeUser?: boolean,
}

const MistakeItem = ({
  answer,
  bb,
  combo,
  ev_c,
  ev_f,
  ev_r,
  stake,
  ts,
  weight_c,
  weight_f,
  weight_r,
  isEasyRFI,
  easyFold,
  seeRange,
  itemData,
  isPlo5,
  isFreeUser,
}: MistakeItemProps) => {
  const [isFreeModalVisible, setFreeModalVisible] = React.useState(false);
  const data = [
    {
      label: 'Raise',
      value: 'raise',
      ev: ev_r,
      weight: weight_r,
    },
    {
      label: 'Call',
      value: 'call',
      ev: ev_c,
      weight: weight_c,
    },
    {
      label: 'Fold',
      value: 'fold',
      ev: ev_f,
      weight: weight_f,
    },
  ].sort((a, b) => b.weight - a.weight);

  const handleEasy = (label) => (
    isEasyRFI && easyFold && label === 'Fold'
  );

  const handleLabel = (label) => {
    if (handleEasy(label)) {
      return 'Easy Fold';
    }
    if (answer.includes('check') && label === 'Call') {
      return 'Check';
    }

    return label;
  };

  const handleNumberStyle = (value) => (
    ((answer.includes('check') && value === 'call') || answer.includes(value))
  );

  return (
    <div className={styles.mistakeItemWrapper}>
      <FreeModal visible={isFreeModalVisible} forControl />
      <div
        className={`${styles.mistakeCards} ${isFreeUser ? styles.freeCursor : styles.okCursor}`}
        onClick={() => seeRange(itemData)}
        onMouseOver={() => (isFreeUser ? setFreeModalVisible(true) : null)}
        onFocus={() => (isFreeUser ? setFreeModalVisible(true) : null)}
        onMouseOut={() => (isFreeUser ? setFreeModalVisible(false) : null)}
        onBlur={() => (isFreeUser ? setFreeModalVisible(false) : null)}
      >
        {
          combo ? sortCards(combo, isPlo5).map((item) => (
            <PlayingCard
              cardMaskShow={false}
              key={item}
              suit={item[1]}
              value={item[0]}
              size="xs"
            />

          ))
            : ''
        }
      </div>
      <div className={styles.mistakeInfo}>
        {data.map((e) => (
          <div className={`${styles.mistakeInfoRow} ${e.weight > 0 ? '' : styles.hidden}`} key={e.value}>
            <span className={`${styles.mistakeInfoAction} ${(handleEasy(e.label)) ? styles.fold : styles[e.value]}`}>
              {handleLabel(e.label)}
            </span>
            <span className={`${handleNumberStyle(e.value) ? styles.call : styles.raise}`}>
              {' '}
              {e.ev.toFixed(3)}
              {`(${e.weight}%)`}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MistakeItem;
